import React from "react"
import { StyledAttrGroup, StyledAttr } from "./partials/StyledAttr"
import IconV2 from "../icon-v2"

export interface HeroFormAttrProps {
  title: string
  icon: string
}

export const HeroFormAttrCmp: React.FC<HeroFormAttrProps> = ({
  title,
  icon,
}) => (
  <StyledAttr>
    {icon && <IconV2 size="16" icon={icon} />}
    {title && <p>{title}</p>}
  </StyledAttr>
)
